import { detect } from 'detect-browser';

export default {
  computed: {
    browserClass() {
      const browser = detect();
      return `is-${browser.name}`;
    },
    isSafari() {
      return navigator.userAgent.indexOf('Safari') !== -1;
    },
    isiOS() {
      return this.browserClass.toLowerCase().includes('ios') || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 0);
    },
    isIPad() {
      return this.browserClass.toLowerCase().includes('ios')
      || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 0)
      || navigator.platform === 'iPad';
    },
    isTouchDevice() {
      return (('ontouchstart' in window)
         || (navigator.maxTouchPoints > 0)
         || (navigator.msMaxTouchPoints > 0));
    },
  },
};
